import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React from 'react';

import StoryShimCursor from './StoryShimCursor';

// Body 03 [Text:Image, Side by Side, 1:2]
// This slide should have text take up 3 grid columns, and the image should take 8 columns + full bleed on right
const StoryBody03 = ({ bodyData }) => {
  const { image, text = '' } = bodyData;
  return (
    <div className="story__body03">
      <StoryShimCursor />
      <p className="text">{text}</p>
      <div className="image">
        <GatsbyImage
          alt="Main cover"
          image={getImage(image)}
          style={{ height: '100%' }}
        />
      </div>
    </div>
  );
};

StoryBody03.propTypes = {
  bodyData: PropTypes.object,
};

export default StoryBody03;
